import ParlourLocations from "./ParlourLocations";

function Parlour() {
  return (
    <>
      {/* Your full screen banner + map above */}
      <ParlourLocations />  {/* Locations list below */}
    </>
  );
}

export default Parlour;
